import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await axios.post('/api/auth/login.php', { username, password }, { withCredentials: true });
      if (remember) {
        localStorage.setItem('saved_username', username);
        localStorage.setItem('saved_password', password);
      } else {
        localStorage.removeItem('saved_username');
        localStorage.removeItem('saved_password');
      }
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || '로그인에 실패했습니다');
    }
  };

  useState(() => {
    const savedUsername = localStorage.getItem('saved_username');
    const savedPassword = localStorage.getItem('saved_password');
    if (savedUsername) { setUsername(savedUsername); setPassword(savedPassword); setRemember(true); }
  }, []);

  return (
    <div style={styles.wrap}>
      <div style={styles.box}>
        <h1 style={styles.title}>새로기획</h1>
        <p style={styles.sub}>관리자 로그인 페이지</p>
        <form onSubmit={handleLogin} style={styles.form}>
          <input
            style={styles.input}
            type="text"
            placeholder="아이디"
            autoFocus
            value={username}
            onChange={e => setUsername(e.target.value)}
          />
          <input
            style={styles.input}
            type="password"
            placeholder="비밀번호"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
          <label style={styles.check}>
            <input type="checkbox" checked={remember} onChange={e => setRemember(e.target.checked)} />
            아이디 및 비밀번호 저장
          </label>
          {error && <p style={styles.error}>{error}</p>}
          <button style={styles.btn} type="submit">로그인</button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  wrap: { minHeight: '100vh', background: '#191919', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Pretendard, sans-serif' },
  box: { background: '#1e1e1f', borderRadius: 16, padding: '48px 40px', width: 360, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 },
  title: { color: '#fff', fontSize: 28, fontWeight: 700, margin: 0 },
  sub: { color: 'rgba(255,255,255,0.4)', fontSize: 13, margin: '4px 0 24px' },
  form: { width: '100%', display: 'flex', flexDirection: 'column', gap: 12 },
  input: { background: '#2a2a2a', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '12px 14px', color: '#fff', fontSize: 14, outline: 'none' },
  check: { color: 'rgba(255,255,255,0.4)', fontSize: 13, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' },
  error: { color: '#ff4d4d', fontSize: 13, margin: 0 },
  btn: { background: '#5755df', color: '#fff', border: 'none', borderRadius: 8, padding: '13px', fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 8 },
};
